export function NotFoundPage() {
  return (
    <main>
      <h1>Not found</h1>
      <p>That link does not exist, or the survey it pointed to has closed.</p>
    </main>
  );
}
